import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGlobalStore = defineStore('global', () => {
    // reactive state
    const site = ref(null)
    const sitename = ref(null)

    // initialize from backend context
    function init(context) {
        site.value = context.site || null
        sitename.value = context.sitename || null
    }

    return { site, sitename, init }
})
